import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useScrollRestoration = () => {
  const location = useLocation();

  useEffect(() => {
    const storageKey = `scroll-${location.key}`;
    const savedScroll = sessionStorage.getItem(storageKey);
    const timer = setTimeout(() => {
      if (savedScroll !== null) {
        window.scrollTo(0, parseInt(savedScroll, 10));
      } else {
        window.scrollTo(0, 0);
      }
    }, 100);

    return () => {
      clearTimeout(timer);
      sessionStorage.setItem(storageKey, String(window.scrollY));
    };
  }, [location.key]);

};

export default useScrollRestoration;

